module.exports = __webpack_public_path__ + "fonts/DM_Sans-200-latin5.3ccd9ab.woff2";